export default __webpack_public_path__ + "static/media/sectors.18ec965b.geojson";